import React, { Children } from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Individuos',
  items: ['Ramos personalizados', 'Suscripciones florales', 'Regalos de aniversario', 'Arreglos para el hogar']
}, {
  title: 'Empresas',
  items: ['Ambientación de oficinas', 'Regalos corporativos', 'Suscripciones semanales', 'Diseño de vitrinas']
}, {
  title: 'Eventos',
  items: ['Bodas íntimas', 'Lanzamientos de marca', 'Cenas privadas', 'Instalaciones florales']
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.2, 0.65, 0.3, 0.9]
    }
  }
};
export function ServiciosSection() {
  return <section className="w-full bg-forest py-32 md:py-48 px-6" data-id="element-107">
      <div className="max-w-6xl mx-auto" data-id="element-108">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1.2,
        ease: [0.2, 0.65, 0.3, 0.9]
      }} className="text-center mb-16 md:mb-20" data-id="element-109">
          <span className="block text-xs md:text-sm tracking-[0.35em] uppercase text-gold mb-6" data-id="element-110">
            Servicios
          </span>
          <h2 className="text-5xl md:text-7xl text-cream italic mb-6" data-id="element-111">
            Nuestros Servicios
          </h2>
          <div className="w-16 h-px bg-gold mx-auto" data-id="element-112" />
        </motion.div>

        {/* Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.15
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-113">
          {services.map(service => <motion.div key={service.title} variants={itemVariants} whileHover={{
          y: -6
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} className="rounded-3xl border border-gold/25 bg-forest/40 backdrop-blur-sm p-8 md:p-10 hover:border-gold/50 transition-colors duration-300" data-id="element-114">
              <h3 className="text-3xl text-cream mb-6 pb-4 border-b border-gold/30 italic" data-id="element-115">
                {service.title}
              </h3>
              <ul className="space-y-5 text-lg text-cream/75" data-id="element-116">
                {service.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-117">
                    <span className="mt-2.5 h-1.5 w-1.5 rounded-full bg-gold flex-shrink-0" data-id="element-118" />
                    {item}
                  </li>)}
              </ul>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}